// Polyfill
import 'core-js/proposals/reflect-metadata';
import 'core-js/stable';
import 'core-js/stage/2';
import 'proxy-polyfill/proxy.min.js';
import 'regenerator-runtime/runtime';
import './fix-un-mount';

import 'react-dates/initialize';
import { setConfig } from 'react-hot-loader';

import './app.scss';

/* import system requirements */
import 'whatwg-fetch';
import './utils/polyfill';
/* external resources */
import './resources/updateOKR';
import './resources/workload';

/* import reactjs dist */
import './addOkr';
import './board';
import './business_group';
import './chatbot';
import './components/common/views.helper';
import './components/global_search/global-search';
import './components/memberProfile/memberProfile.component';
import './components/okr/modals/okr-export-excel.wobo';
import './components/okr/modals/okr-publish';
import './components/wsObjective';
import './customWsAttributes';
import './directDotted';
import './editCascadeKr';
import './extPublish';
import './fullAlignment';
import './full_board';
import './goalaligns';
import './kr-results';
import './krImportFeed';
import './lists';
import './meeting';
import './my-okr';
import './navbar';
import './notification';
import './okr-history';
import './personkr.search';
import './preferences';
import './profile';
import './teampage.okr';
import './this_week';
import './wsImport';
import './ws_summary';
import Highcharts from 'highcharts/highcharts'; // global highcharts instance
import Exporting from 'highcharts/modules/exporting';
import Stock from 'highcharts/modules/stock';
import XRangeModule from 'highcharts/modules/xrange';
import './apps/engagement-report';
import './apps/feedback';
import './apps/user-preferences';
import './apps/user-delegates';
import './apps/loader';
import './apps/project-management';
import './apps/sps/app.wobo';
import './apps/teams-management';
import './apps/teams-management/landing-page';
import './apps/team-settings-admin';
import './apps/timeline';
import './apps/kanban';
import './apps/my-work-calendar';
import './apps/workstreams';
import './apps/agent-prompt-manager';
import './board/modals/index';
import './admin-modal-handler';
import './apps/admin-workday-integrations';
import './apps/admin-integrations-reporting-filters';
import './components/component-mounts';
import './components/modals/compliance_ack';
import './components/modals/skipLink';
import './components/okr/modals/kr-modal';
import './components/okr/okr_sub_components/kr.hover.Spec_Key_result';
import './krCalPopUp';
import './okr/modals';
import './apps/okr/okr-dialog-host/openFederatedOkrDialog';
import './apps/okr/kr-side-panel-host/openFederatedKrSidePanel';
import './krr/modals';
import './orgResults';

Exporting(Highcharts);
Stock(Highcharts);
XRangeModule(Highcharts);

const initTabListeners = () => {
  window.addEventListener('keydown', (e) => {
    if (e.type === 'keydown' && e.keyCode === 9 && typeof document.body !== 'undefined') {
      document.body.classList.add('is-tabbing');
    }
  });

  window.addEventListener('click', (e) => {
    if (e.type === 'click' && e.pageX !== 0 && e.pageY !== 0 && typeof document.body !== 'undefined') {
      document.body.classList.remove('is-tabbing');
    }
  });
};

initTabListeners();
// Webpack removes this for production
if (module.hot) {
  setConfig({ logLevel: 'debug' });
  module.hot.accept();
}

import('./app'); // mount the react app using an asynchronous boundary - see https://webpack.js.org/concepts/module-federation/#uncaught-error-shared-module-is-not-available-for-eager-consumption
